import { ReactElement } from "react";

import {
  Button,
  ButtonProps,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { DesktopOnly, MobileOnly } from "components/BreakpointVisibility";
import PreventNavigationAlert from "components/PreventNavigationAlert";
import { CloseIcon } from "icons";
import { mobileStyleBreakpoint } from "util/styleHelpers";

const CancelButtonAlert = ({
  onCancel,
  displayAlert,
  ...rest
}: {
  onCancel: () => void;
  displayAlert: boolean;
} & ButtonProps): ReactElement => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const buttonMarginBottom = mobileStyleBreakpoint<number>(6, 0);
  const buttonMarginTop = mobileStyleBreakpoint<number>(4, 0);

  return (
    <>
      <DesktopOnly>
        <IconButton
          icon={<CloseIcon />}
          aria-label="Close"
          variant="link"
          colorScheme="gray"
          onClick={displayAlert ? onOpen : onCancel}
          {...rest}
        />
      </DesktopOnly>
      <MobileOnly>
        <Button
          bg="grey.200"
          color="black"
          onClick={displayAlert ? onOpen : onCancel}
          mb={buttonMarginBottom}
          mt={buttonMarginTop}
        >
          Close
        </Button>
      </MobileOnly>
      <PreventNavigationAlert
        onClose={onClose}
        isOpen={isOpen}
        onContinue={onCancel}
        message="Any unsaved changes will be lost."
      />
    </>
  );
};
export default CancelButtonAlert;
